module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.show.category) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center border"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣分類")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.category), function(category, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(category.name) + "\n          ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.show.product) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center border"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣商品")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.product), function(product, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(product.name) + "\n          ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.show.adjust) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center border"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣調整類別")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.adjust), function(adjust, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(adjust.name) + "\n          ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.show.option) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣調整項目")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.option), function(option, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(option.name) + "\n          ")])])
  }), 0)])])]) : _vm._e(), _vm._v(" "), (_vm.show.combination) ? _c('div', {
    staticClass: "col-xs-12 col-md-3 p-10 text-center border"
  }, [_c('h4', {
    staticClass: "text-red"
  }, [_vm._v("停賣組合")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid"
    }
  }, [_c('tbody', _vm._l((_vm.disTableList.combination), function(combination, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v("\n            " + _vm._s(index + 1) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(combination.name) + "\n          ")])])
  }), 0)])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89fa8176"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/RealTime/Temp/DisItemTableTemp.vue
// module id = 2513
// module chunks = 1